import {useSelector} from 'Provider';
import {DateTime} from 'luxon';
import {View} from 'native-base';
import React from 'react';

import FilterBarAccordion from 'components/FilterBarAccordion';
import {selectedFilterSelector} from 'store/offers/offers.selectors';

import OfferFilter from '../Filter';
import OfferFilterDatesToggle from './Toggle';

export interface OfferFilterDateProps {
  disabled?: boolean;
  toggle?: boolean;
  onToggle?: () => void;
}

const OfferFilterDate: React.FC<OfferFilterDateProps> = props => {
  const {disabled, toggle, onToggle} = props;
  const selectedFilters = useSelector(selectedFilterSelector);
  const start = selectedFilters.startDate;
  const end = selectedFilters.endDate;

  const startDate = start && DateTime.fromISO(start).toFormat('ccc, LLL d');
  const endDate = end && DateTime.fromISO(end).toFormat('ccc, LLL d');
  let dateString = '';

  if (startDate && endDate) {
    dateString = `${startDate} — ${endDate}`;
  } else if (startDate) {
    dateString = startDate;
  } else if (endDate) {
    dateString = endDate;
  }

  return (
    <View width="100%">
      <FilterBarAccordion
        toggle={toggle}
        accordionTop={
          <OfferFilter
            title="Dates"
            icon="calendar-alt"
            altText={dateString}
            isOpen={toggle}
            onToggle={onToggle}
          />
        }
        accordionBody={<OfferFilterDatesToggle disabled={disabled} />}
      />
    </View>
  );
};

export default OfferFilterDate;
